module.exports = __webpack_public_path__ + "static/images/list-p-a.94dd4f5.png";